export const API_ERROR = "API_COMMS_ERROR";
export const CLEAR_API_ERRORS = "CLEAR_API_ERRORS";
export const CONFIRM_SAVED_COMMUNICATION_PREFERENCES =
  "CONFIRM_SAVED_COMMUNICATION_PREFERENCES";
export const RECEIVE_PREFERENCES = "RECEIVE_PREFERENCES";
export const REQUEST_PREFERENCES = "REQUEST_PREFERENCES";
export const TRACK_SAVED_COMMUNICATION_PREFERENCES =
  "TRACK_SAVED_COMMUNICATION_PREFERENCES";
